import React, { useEffect, useState } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import RestService from '../Services/RestService';
import OKomLoading from '../Components/OsloKommuneUI/OKomLoading';
import OKomBreadcrumb from '../Components/OsloKommuneUI/OKomBreadcrumb';
import { useUserContext } from '../Components/StateContext/UserContext';

const TILES_PER_ROW = 3;

const badgeStyle: React.CSSProperties = {
  position: 'absolute',
  top: '0.5rem',
  right: '0.5rem',
  minWidth: '1.5rem',
  height: '1.5rem',
  padding: '0 0.4rem',
  borderRadius: '0.75rem',
  background: '#2a2859',
  color: '#fff',
  fontSize: '0.8rem',
  fontWeight: 700,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  lineHeight: 1,
};

const renderAccount = (account: Api.MailboxAccountInfo, key: number) => {
  const card = (
    <div className="ods-status-card frontpage-card" style={{ position: 'relative' }}>
      {account.Count > 0 && (
        <span style={badgeStyle} aria-label={`${account.Count} meldinger`}>{account.Count}</span>
      )}
      <div className="ods-status-card__content">
        <span className="ods-icon ods-icon--size-kilo ods-icon--size-echo-breakpoint-medium ods-icon--email" aria-hidden="true"></span>
        <span className="ods-text--size-kilo ods-text--size-echo-breakpoint-medium" title={account.Email}>{account.Email.split('@')[0]}</span>
      </div>
    </div>
  );
  return (
    <div key={key} className="ods-grid__column--4">
      <a href={`/fellesepost/${account.Key}`} className="o-kom-link" style={{ display: 'block' }}>{card}</a>
    </div>
  );
};

const EpostKontoerView: React.FC<RouteComponentProps> = () => {
  const { userRoles } = useUserContext();
  const isAdmin = userRoles.includes('admin');

  const [isLoading, setIsLoading] = useState(false);
  const [accounts, setAccounts] = useState<Api.MailboxAccountInfo[]>([]);

  useEffect(() => {
    if (!isAdmin) return;
    (async () => {
      try {
        setIsLoading(true);
        const data = await RestService.get<Api.MailboxAccountInfo[]>('/api/mailbox/Accounts');
        setAccounts(data ?? []);
      } catch (e) {
        toast.error(`Kunne ikke laste e-postkontoer: ${e}`);
      } finally {
        setIsLoading(false);
      }
    })();
  }, [isAdmin]);

  if (!isAdmin) {
    return (
      <>
        <OKomBreadcrumb path='Felles epost' />
        <div className="ods-grid ods-grid--center ods-margin-top-25">
          <div className="ods-grid__column--8">
            <div className="ods-status-card ods-color-bg-red-light">
              <div className="ods-status-card__content">
                <span className="ods-text--size-kilo">Ingen tilgang. Denne siden er kun for administratorer.</span>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  const rows: Api.MailboxAccountInfo[][] = [];
  for (let i = 0; i < accounts.length; i += TILES_PER_ROW) {
    rows.push(accounts.slice(i, i + TILES_PER_ROW));
  }

  return (
    <>
      <OKomBreadcrumb path='Felles epost' />
      {isLoading && <OKomLoading text='Henter e-postkontoer …' />}
      {rows.map((row, rowIndex) => (
        <div key={rowIndex} className="ods-grid ods-grid--gap-row-large ods-margin-top-11 ods-text--align-center">
          <div className="ods-grid__column--12">
            <div className="ods-grid ods-grid--gap ods-grid--center">
              {row.map((a, colIndex) => renderAccount(a, rowIndex * TILES_PER_ROW + colIndex))}
            </div>
          </div>
        </div>
      ))}
      {accounts.length === 0 && !isLoading && (
        <div className="ods-grid ods-grid--center ods-margin-top-11">
          <div className="ods-grid__column--8 ods-text--align-center">Ingen e-postkontoer konfigurert.</div>
        </div>
      )}
    </>
  );
};

export default withRouter(EpostKontoerView);
